import Mediator from './Mediator';

class Lesson extends Mediator {
  constructor(rawData) {
    super(rawData);

    this.setVersion('v1', [
      'classroom_id', 'classroom_name', 'lesson_end_time', 'lesson_start_time',
      'lesson_id', 'lesson_iso_weekday', 'lesson_minutes', 'lesson_name',
      'lesson_number', 'lesson_status', 'student_absent_amount',
      'student_amount', 'student_attend_amount', 'student_call_sick_amount',
      'student_late_amount', 'student_list', 'teacher_unchecked_amount',
      'teacher_list', 'teacher_checked_amount', 'calendar_color',
      'note',
     ], {});
    
    this.setVersion('v2', [
      'allDay', 'class_name', 'class_type', 'classroom_name',
      'id', 'lCalendarColor', 'lClass', 'lClassroom',
      'lDuration', 'lEndTime', 'lName', 'lStartTime',
      'lState', 'lesson_number', 'student_amount',
      'teacher_list', 'title', 'note',
    ], {});

    this.__schema = {
      id: { alias: ['lesson_id', 'id'] },
      name: { alias: ['lesson_name', 'name', 'lName'] },
      title: { alias: ['title'] },
      endTime: { alias: ['lesson_end_time', 'end_time', 'lEndTime'] },
      startTime: { alias: ['lesson_start_time', 'start_time', 'lStartTime'] },
      isoWeekday: { alias: ['lesson_iso_weekday', 'iso_weekday'] },
      minutes: { alias: ['lesson_minutes', 'minutes'] },
      lessonNumber: { alias: ['lesson_number'] },
      status: { alias: ['lesson_status', 'status', 'lState'] },

      allDay: { alias: ['allDay'] },
      duration: { alias: ['lDuration', 'duration'] },
      
      classId: { alias: ['lClass'] },
      className: { alias: ['class_name'] },
      classType: { alias: ['class_type'] },
      
      classroomId: { alias: ['classroom_id', 'lClassroom'] },
      classroomName: { alias: ['classroom_name', 'classroom_name'] },
      
      studentAbsentAmount: { alias: ['student_absent_amount'] },
      studentAmount: { alias: ['student_amount'] },
      studentAttendAmount: { alias: ['student_attend_amount'] },
      studentCallSickAmount: { alias: ['student_call_sick_amount'] },
      studentLateAmount: { alias: ['student_late_amount'] },
      studentList: { alias: ['student_list', 'studentList'] },
      
      teacherList: { alias: ['teacher_list'] },
      teacherCheckedAmount: { alias: ['teacher_checked_amount'] },
      teacherUncheckedAmount: { alias: ['teacher_checked_amount'] },
      
      calendarColor: { alias: ['calendar_color', 'calendarColor'] },
      note: { alias: ['note'] },
    }

    return this.create();
  }

  getDate() {
    let { startTime } = this.__privateData;
    if (startTime) {
      let parts = startTime.split(" ");
      return parts[0];
    }
  }
  
  getStartTime() {
    let { startTime } = this.__privateData;
    if (startTime) {
      let parts = startTime.split(" ");
      // return parts[1].substring(0, parts[1].length - 3);
      return parts[1];
    }
  }
  
  getEndTime() {
    let { endTime } = this.__privateData;
    if (endTime) {
      let parts = endTime.split(" ")
      return parts[1];
    }
  }
  
  getClassroom() {
    return {
      id: this.__privateData.classroomId,
      name: this.__privateData.classroomName,
    }
  }

  getTeacherIdList() {
    if (Array.isArray(this.__privateData.teacherList)) {
      return this.__privateData.teacherList.map((teacher)=>{
        return teacher.id;
      });
    } else {
      return [];
    }
  }

  getStudentIdList() {
    if (Array.isArray(this.__privateData.studentList)) {
      return this.__privateData.studentList.map((student)=>{
        return student.id;
      });
    } else {
      return [];
    }
  }

}

export default Lesson;




// WEBPACK FOOTER //
// ./src/mediators/Lesson.js